import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { AdminsAvatarsComponent, AvatarUser } from '@core/account-ui';
import { Helpers } from '@core/common-legacy';
import { EvaluationInsight } from '@core/evaluation-insights-types';
import { EvaluationQuickInsightComponent } from '@core/evaluation-insights-ui';
import { TranslatePipe } from '@core/i18n-legacy';
import { HeadingComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-evaluation-tooltip',
  imports: [
    HeadingComponent,
    AdminsAvatarsComponent,
    TranslatePipe,
    EvaluationQuickInsightComponent,
  ],
  templateUrl: './evaluation-tooltip.component.html',
  styleUrl: './evaluation-tooltip.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'rt-card',
    '[class.with-insights]': 'isInsightsVisible()',
  },
})
export class EvaluationTooltipComponent {
  public tooltipText = input<string>();
  public insight = input<EvaluationInsight | null>(null);
  public isInsightsVisible = input<boolean>();
  public users = input<AvatarUser[]>([]);

  protected insightQuickContent = computed(() => {
    const insight = this.insight();
    if (!insight || insight.hidden) return '';

    return `${Helpers.stripHtml(insight.content).substring(0, 250).trim()}...`;
  });
}
